import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { SupervisorReportService } from '../../services/supervisor-report.service';
import { EmployeeService } from '../../services/employee.service';
import { ProductionOrderService } from '../../services/production-order.service';
import { ShipService } from '../../services/ship.service';
import { AuthService } from '../../services/auth.service';

import { Utils } from '../../util';

@Component({
  selector: 'app-create-supervisor-report',
  templateUrl: './create-supervisor-report.component.html',
  styleUrls: ['./create-supervisor-report.component.css', '../../app.component.css']
})

export class CreateSupervisorReportComponent implements OnInit, OnDestroy {

  reportForm: FormGroup;
  report: any;

  supervisors = {};
  supervisorInit: any;
  supervisorText = '';

  projects = {};
  projectInit: any;
  projectText = '';

  ships = {};
  shipInit: any;
  shipText = '';

  pickadateParams = Utils.pickadateParams();
  pickatimeParams = Utils.pickatimeParams();

  geSubs: any;
  gpoSubs: any;
  gsSubs: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private supervisorReportService: SupervisorReportService,
    private employeeService: EmployeeService,
    private productionOrderService: ProductionOrderService,
    private shipService: ShipService,
    private authService: AuthService
  ) {
    this.loadSupervisorsAndProjectsAndShips();
  }

  ngOnInit() {
    this.reportForm = this.formBuilder.group({
      supervisor: ['', Validators.required],
      project: ['', Validators.required],
      reportDate: ['', Validators.required],
      startTime: ['', Validators.required],
      endTime: ['', [Validators.required]],
      ship: ['', Validators.required]
    });
  }

  onSubmitReport() {
    this.report = this.saveReport();

    this.supervisorReportService.postSupervisorReport(this.report).then(res => {
      this.reportForm.reset();
      this.router.navigate(['/edt_supervisor_report/', res]);
    });
  }

  saveReport() {
    const reportDate = Utils.convertDatefromISOStringtoObject(this.reportForm.get('reportDate').value);
    const currentDate = new Date();
    const userSession = this.authService.currentUser;

    const reportJson = {
      active: 1,
      createdAt: currentDate,
      employeeId: this.supervisors[this.reportForm.get('supervisor').value],
      endTime: this.reportForm.get('endTime').value,
      productionOrderId: this.projects[this.reportForm.get('project').value],
      reportDate:  reportDate,
      shipId: this.ships[this.reportForm.get('ship').value],
      startTime: this.reportForm.get('startTime').value,
      updatedAt: currentDate,
      employees: {},
      captureUser: userSession['email']
    };

    return reportJson;
  }

  loadSupervisorsAndProjectsAndShips() {
    this.geSubs = this.employeeService.getEmployees().subscribe(tempSupervisors => {
      const dataEmployee = {};

      for (const idx in tempSupervisors) {
        let employeeDisplayValue = `${tempSupervisors[idx].name} ${tempSupervisors[idx].lastName} (${tempSupervisors[idx].internalKey})`;
        dataEmployee[employeeDisplayValue] = null;
        this.supervisors[employeeDisplayValue] = tempSupervisors[idx].id$;
      }

      this.supervisorInit = {
        'data': dataEmployee,
        onAutocomplete: (val) => { // console.log(val); // console.log(this.supervisors[val]);
        }
      };
    });

    this.gpoSubs = this.productionOrderService.getProductionOrders().subscribe(tempProjects => {
      const dataProject = {};

      for (const idx in tempProjects) {
        dataProject[tempProjects[idx].name] = null;
        this.projects[tempProjects[idx].name] = tempProjects[idx].id$;
      }

      this.projectInit = {
        'data': dataProject,
        onAutocomplete: (val) => { // console.log(val); // console.log(this.projects[val]);
        }
      };
    });

    this.gsSubs = this.shipService.getShips().subscribe(tempShips => {
      const dataShip = {};

      for (const idx in tempShips) {
        dataShip[tempShips[idx].description] = null;
        this.ships[tempShips[idx].description] = tempShips[idx].id;
      }

      this.shipInit = {
        'data': dataShip,
        onAutocomplete: (val) => { // console.log(val); // console.log(this.ships[val]);
        }
      };
    });
  }

  onBlurSupervisor() {
    if (this.supervisors[this.supervisorText] === undefined) {
      this.supervisorText = '';
    }
  }

  onBlurProject() {
    if (this.projects[this.projectText] === undefined) {
      this.projectText = '';
    }
  }

  onBlurShip() {
    if (this.ships[this.shipText] === undefined) {
      this.shipText = '';
    }
  }

  ngOnDestroy() {
    this.geSubs.unsubscribe();
    this.gpoSubs.unsubscribe();
    this.gsSubs.unsubscribe();
  }

}
